import { createFileRoute } from '@tanstack/react-router';
import Tabs from '@/components/ui/tabs';
import NotifactionTable from '@/featured/dashboard/notification/notification-zone-table';

export default function HistoryNotification() {
  return (
    <div className="w-full bg-white dark:bg-gray-800 p-4 rounded-lg shadow-sm transition-colors duration-300">
      <Tabs>
        <Tabs.MenuGroup className="justify-around">
          <Tabs.Menu index={0} title="Zone" />
          <Tabs.Menu index={1} title="Voyager" />
        </Tabs.MenuGroup>
        <Tabs.PanelGroup>
          <Tabs.Panel index={0}>
            <NotifactionTable alias="EZ" orderBy="received_at" orderType="desc" />
          </Tabs.Panel>
          <Tabs.Panel index={1}>
            <NotifactionTable alias="AV" orderBy="created_at" orderType="desc" />
          </Tabs.Panel>
        </Tabs.PanelGroup>
      </Tabs>
    </div>
  );
}

export const Route = createFileRoute('/_authenticated/dashboard/notifications/history')({
  component: HistoryNotification,
});
